import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { ContactDetailEffects } from './effects';
import { contactDetailFeatureKey, contactDetailReducer } from './reducers';

@NgModule({
  imports: [
    StoreModule.forFeature(contactDetailFeatureKey, contactDetailReducer),
    EffectsModule.forFeature([ContactDetailEffects]),
  ],
})
export class ContactDetailStoreModule {}
